import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import Question from './sub-components/question/question.jsx';
import AttractorTimeout from '../warning/attractorTimeout';
import Modal from '../feedstock/sub-components/modal/modal';
import shuffle from 'lodash.shuffle'

const PuzzleScreen = ({config, gameData, passRefUpward}) => {
    const [showRestartModal, setShowRestartModal] = useState(false);
    const [currentQuestionNumber, setCurrentQuestionNumber] = useState(1);
    const [resetToHome, setResetToHome] = useState(false);
    const [questions, setQuestions] = useState([]);
    const [answerTotals, setAnswerTotals] = useState({
        words: {
            score: 0,
            hints: 0,
            totalCorrect: 0
        },
        shapes: {
            score: 0,
            hints: 0,
            totalCorrect: 0
        },
        numbers: {
            score: 0,
            hints: 0,
            totalCorrect: 0
        }
    });

    const filterQuestions = (questions) => {
        let shapeQuestions = questions.filter(question => question.category === "Shapes");
        let numberQuestions = questions.filter(question => question.category === "Words");
        let wordQuestions = questions.filter(question => question.category === "Numbers");
        const selectedQuestions = [...getRandomQuestions(shapeQuestions, 3), ...getRandomQuestions(numberQuestions, 3), ...getRandomQuestions(wordQuestions, 3)];
        return shuffle(selectedQuestions);
    };

    const getRandomQuestions = (questions, n) => {
        return shuffle(questions).slice(0, n);
    };

    // Path.join not working correctly on windows
    let questionPath;
    if (config.configPath.includes('/')) {
        questionPath = config.configPath.split('/').slice(0, -1).join('/') + '/questions/puzzle-screen-questions/questions.json';
    } else if (config.configPath.includes('\\')) {
        questionPath = config.configPath.split('\\').slice(0, -1).join('\\') + '\\questions\\puzzle-screen-questions\\questions.json';
    }

    useEffect(() => {
        fetch(questionPath)
            .then(res => res.json())
            .then(data => {
                const {questions} = data;
                const filteredQuestions = filterQuestions(questions);
                setQuestions(filteredQuestions);
            })
            .catch(err => console.log(err));
    // eslint-disable-next-line
    }, [questionPath]);

    AttractorTimeout(config, passRefUpward);

    const restartGame = (isConfirmed) => {
        if (isConfirmed) {
            setResetToHome(true);
        }
    };

    const {
        restart_quiz_title,
        restart_quiz_text,
        restart_quiz_button,
        restart_quiz_close_button,
    } = config.screens.puzzleScreen;

    return resetToHome ?
        <Redirect push to="/" />
        : questions.length ?
        <>
            <div className="puzzle-screen-component">
                {currentQuestionNumber > questions.length &&
                    <Redirect push to={{
                        pathname: '/leaderboard',
                        state: {answerTotals}
                    }}/>
                }

                {questions.map((question, index) => {
                    return (
                        <CSSTransition
                            key={`question${index + 1}`}
                            appear in={currentQuestionNumber === index + 1}
                            classNames="fade"
                            timeout={{enter: 600, exit: 300}}
                            unmountOnExit
                        >
                            <Question
                                config={config}
                                question={question}
                                gameData={gameData}
                                currentQuestionNumber={index + 1}
                                setCurrentQuestionNumber={setCurrentQuestionNumber}
                                answerTotals={answerTotals}
                                setAnswerTotals={setAnswerTotals}
                                setShowRestartModal={setShowRestartModal}
                            />
                        </CSSTransition>
                    )
                })}
            </div>

            <CSSTransition
                appear
                in={showRestartModal}
                classNames="fade"
                timeout={300}
                unmountOnExit
            >
                <Modal
                    text={restart_quiz_text}
                    title={restart_quiz_title}
                    closeText={restart_quiz_close_button}
                    restartButtonText={restart_quiz_button}
                    closeFunction={setShowRestartModal}
                    modalType="correct"
                    restartQuiz
                    restartQuizFunc={restartGame}
                />
            </CSSTransition>
        </>
    : <div className="puzzle-screen-component"> </div>;
};

export default PuzzleScreen;
